import React from 'react'
import HomePages from './HomePages'

function index() {
  return (
    <>
      <HomePages />
    </>
  )
}

export default index
